import { IAppConfig } from 'portalServices';
import { environment } from '../../environments/environment';

export function getServiceConfig(): IAppConfig
{
    return {
        apiEndpoint: environment.apiUrl,
        domainName: environment.domainName || window.location.host
    };
}
